const KeyDateCardSkeleton = () => (
  <div className="flex flex-col gap-3 rounded-[14px] border-2 border-[#d0e2df] bg-white p-[18px]">
    <div className="flex items-center gap-3">
      <div className="h-12 w-12 animate-pulse rounded-full bg-gray-200" />
      <div className="flex flex-col gap-2">
        <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
        <div className="h-3 w-16 animate-pulse rounded bg-gray-200" />
      </div>
    </div>
    <div className="h-5 w-3/4 animate-pulse rounded bg-gray-200" />
    <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
    <div className="h-4 w-2/3 animate-pulse rounded bg-gray-200" />
  </div>
);

export const KeyDatesSectionSkeleton = () => (
  <div className="mb-sh-30">
    <div className="mb-sh-15 h-8 w-32 animate-pulse rounded bg-gray-200" />
    <div className="mb-sh-30 h-5 w-64 animate-pulse rounded bg-gray-200" />
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      <KeyDateCardSkeleton />
      <KeyDateCardSkeleton />
      <KeyDateCardSkeleton />
      <KeyDateCardSkeleton />
      <KeyDateCardSkeleton />
      <KeyDateCardSkeleton />
    </div>
    <div className="mt-sh-30">
      <div className="h-10 w-36 animate-pulse rounded-lg bg-gray-200" />
    </div>
  </div>
);
